import React, { useEffect, useState } from "react";
import { Alert, Card, ListGroup, Spinner } from "react-bootstrap";
import API from "../services/api";
import "./VendorNotifications.css";

const VendorNotifications = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await API.get("/vendor/notifications");
        setItems(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Failed to load vendor notifications", err);
        setError("Unable to load notifications right now.");
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  if (loading) {
    return (
      <div className="text-center mt-4">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="mt-3">
        {error}
      </Alert>
    );
  }

  return (
    <Card className="shadow-sm vn-card">
      <Card.Header className="bg-primary text-white">Notifications</Card.Header>
      <ListGroup variant="flush">
        {items.length ? (
          items.map((n) => (
            <ListGroup.Item key={n.id || n._id || n.date || n.message}>
              <div className="fw-semibold">{n.message || "Notification"}</div>
              <div className="text-muted small">
                {n.date ? new Date(n.date).toLocaleString() : ""}
              </div>
            </ListGroup.Item>
          ))
        ) : (
          <ListGroup.Item className="text-muted">No notifications yet.</ListGroup.Item>
        )}
      </ListGroup>
    </Card>
  );
};

export default VendorNotifications;
